export const letterSpacings = {
  // empty
}

export type LetterSpacings = typeof letterSpacings
export type LetterSpacingsType = keyof LetterSpacings
